function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

import _map from 'lodash/map';
import _each from 'lodash/each';
import _ceil from 'lodash/ceil';
import _find from 'lodash/find';
import _floor from 'lodash/floor';
import _filter from 'lodash/filter';
import _flatten from 'lodash/flatten';
import _isEqual from 'lodash/isEqual';
import _debounce from 'lodash/debounce';
import _toInteger from 'lodash/toInteger';
import React from 'react';
import PropTypes from 'prop-types';
import d3Legacy from 'd3-legacy';
import { getCurrentD3Locale } from 'js/helpers/dateTimeAndNumberFormatting';
import GraphDownloadButton from 'js/containers/legacy/GraphDownloadButton';
import PlotSampleRateRadios from 'js/containers/legacy/PlotSampleRateRadios';
import SelectedGeneratorsDesktop from 'js/containers/legacy/SelectedGeneratorsDesktop';
import SelectedGeneratorsMobile from 'js/containers/legacy/SelectedGeneratorsMobile';
import { multiplotGraph } from 'json/shared_styles.json';
var Y_AXIS_LABEL = 'MWh';
var NUMBER_OF_Y_TICKS = 6; // MS_IN_A_MONTH = 2628000000,

var MS_IN_A_DAY = 86400000;
var Y_AXIS_LABEL_X = 10;
var Y_AXIS_LABEL_Y = -10;
var HOVER_DATE_TOP_MARGIN = -20;
var HOVER_DATE_SIDE_PADDING = 9;
var HOVER_DATE_TOP_BOTTOM_PADDING = 7;
var MAIN_NODE_SIZE = 8;
var SURROUNDING_NODE_SIZE = 4;
var PREVIOUS_NODE_KEY = 'previous';
var NEXT_NODE_KEY = 'next';
var CURRENT_NODE_KEY = 'current';
var TOOLTIP_X_MARGIN = 50;
var TOOLTIP_Y_MARGIN = 5;
var TOOLTIP_SIDE_PADDING = 9;
var TOOLTIP_TOP_BOTTOM_PADDING = 7;
var MARGIN_DESKTOP = {
  top: 60,
  right: 20,
  bottom: 70,
  left: 30
};
var MARGIN_BRUSH_DESKTOP = {
  top: 530,
  bottom: 10,
  left: 30
};
var TOTAL_HEIGHT = multiplotGraph.height;
var GRAPH_HEIGHT = TOTAL_HEIGHT - MARGIN_DESKTOP.top - MARGIN_DESKTOP.bottom;
var BRUSH_HEIGHT = TOTAL_HEIGHT - MARGIN_BRUSH_DESKTOP.top - MARGIN_BRUSH_DESKTOP.bottom;
var bisectDate = d3Legacy.bisector(mapGeneratorDataPointToXValue).left;

var TimeGraph =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimeGraph, _React$Component);

  function TimeGraph(props) {
    var _this;

    _classCallCheck(this, TimeGraph);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeGraph).call(this, props));
    _this.state = {};
    _this._plotDateRangeUpdate = _this._plotDateRangeUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._hideAllHoverElements = _this._hideAllHoverElements.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._debouncedUpdatePlot = _debounce(_this.updatePlot.bind(_assertThisInitialized(_assertThisInitialized(_this))), 100);
    return _this;
  }

  _createClass(TimeGraph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderTimeGraph(this.props.plotData);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if (this.props.windowWidth != newProps.windowWidth) this._debouncedUpdatePlot(newProps);
      if (!_isEqual(this.props.plotData, newProps.plotData)) this.updatePlot(newProps);
    }
  }, {
    key: "_hideAllHoverElements",
    value: function _hideAllHoverElements() {
      _each(this.state.nodeElements, hideD3Element);

      hideD3Element(this.state.xCrossHair);
      hideD3Element(this.state.hoverDate);
    }
  }, {
    key: "_plotDateRangeUpdate",
    value: function _plotDateRangeUpdate(dateRange) {
      this._hideAllHoverElements();

      this.state.brush.extent(dateRange);
      this.state.xBrushElement.transition().duration(0).call(this.state.brush);
      this.updateDomainsLinesAndAxes(this.props.plotData);
    }
  }, {
    key: "updatePlot",
    value: function updatePlot() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      if (!this.state.svg) return this.renderTimeGraph(props.plotData);
      this.updateTimeGraph(props.plotData);
    }
  }, {
    key: "renderTimeGraph",
    value: function renderTimeGraph(data) {
      if (!data.length) return;
      this.setUpWidthDependentVariables().then(this.setUpDomainsScalesAndAxes.bind(this, data)).then(this.appendSvgElement.bind(this)).then(this.updateSvgElement.bind(this)).then(this.appendFocusElement.bind(this)).then(this.updateFocusLines.bind(this, data)).then(this.appendBrushContextElement.bind(this)).then(this.appendAxes.bind(this)).then(this.appendHoverElements.bind(this)).then(this.appendNodesForEachGenerator.bind(this, data)).then(this.appendOverlayElement.bind(this)).then(this.updateOverlayElement.bind(this, data)).then(this.bindBrush.bind(this, data));
    }
  }, {
    key: "updateTimeGraph",
    value: function updateTimeGraph(data) {
      if (!data.length) return;
      this.setUpWidthDependentVariables().then(this.updateDomainsScalesAndAxes.bind(this, data)).then(this.updateSvgElement.bind(this)).then(this.updateFocusLines.bind(this, data)).then(this.updateBrushContextElement.bind(this)).then(this.updateAxes.bind(this)).then(this.appendNodesForEachGenerator.bind(this, data)).then(this.updateOverlayElement.bind(this, data)).then(this.bindBrush.bind(this, data));
    }
  }, {
    key: "setUpWidthDependentVariables",
    value: function setUpWidthDependentVariables() {
      var _this2 = this;

      // Set the dimensions of the canvas / graph
      return new Promise(function (resolve) {
        var currentTotalWidth = document.getElementById(_this2.props.plotSectionGraphId).offsetWidth;
        var currentGraphWidth = currentTotalWidth - MARGIN_DESKTOP.left - MARGIN_DESKTOP.right;

        var maxNumberOfXTicks = _floor(currentTotalWidth / 80);

        _this2.setState({
          currentTotalWidth: currentTotalWidth,
          currentGraphWidth: currentGraphWidth,
          maxNumberOfXTicks: maxNumberOfXTicks
        }, resolve);
      });
    }
  }, {
    key: "setUpDomainsScalesAndAxes",
    value: function setUpDomainsScalesAndAxes(data) {
      var _this3 = this;

      return new Promise(function (resolve) {
        // Set the ranges
        var totalXDomain = d3Legacy.extent(getAllDates(data));
        var totalYDomain = d3Legacy.extent(getAllValues(data));
        var xAxisScale = d3Legacy.time.scale().domain(totalXDomain).range([0, _this3.state.currentGraphWidth]);
        var xBrushAxisScale = d3Legacy.time.scale().domain(totalXDomain).range([0, _this3.state.currentGraphWidth]);
        var yAxisScale = d3Legacy.scale.linear().domain(totalYDomain).range([GRAPH_HEIGHT, 0]); // Define the axes

        var xAxisInfo = d3Legacy.svg.axis().scale(xAxisScale).orient('bottom').ticks(_this3.getXTicksGenerator(data)).tickFormat(formatBrushXAxisDate).outerTickSize(0);
        var xAxisBrush = d3Legacy.svg.axis().scale(xBrushAxisScale).orient('bottom').ticks(_this3.getXTicksGenerator(data)).tickFormat(formatBrushXAxisDate).outerTickSize(0);
        var yAxisInfo = d3Legacy.svg.axis().scale(yAxisScale).orient('left').ticks(NUMBER_OF_Y_TICKS).outerTickSize(0);
        var brush = d3Legacy.svg.brush().x(xBrushAxisScale).extent(totalXDomain); // Define the line

        var timeGraphLine = d3Legacy.svg.line().x(function (generator) {
          return mapGeneratorDataPointAndXAxisScaleToGraphX(generator, xAxisScale);
        }).y(function (generator) {
          return mapGeneratorDataPointAndYAxisScaleToGraphY(generator, yAxisScale);
        });
        var updatedState = {
          totalXDomain: totalXDomain,
          totalYDomain: totalYDomain,
          xAxisScale: xAxisScale,
          yAxisScale: yAxisScale,
          xAxisBrush: xAxisBrush,
          xAxisInfo: xAxisInfo,
          yAxisInfo: yAxisInfo,
          xBrushAxisScale: xBrushAxisScale,
          brush: brush,
          timeGraphLine: timeGraphLine
        };

        if (domainIsOutsideOfTotalDomain(_this3.state.currentXDomain, totalXDomain)) {
          updatedState.currentXDomain = totalXDomain;
        }

        if (domainIsOutsideOfTotalDomain(_this3.state.currentYDomain, totalYDomain)) {
          updatedState.currentYDomain = totalYDomain;
        }

        _this3.setState(updatedState, resolve);
      });
    }
  }, {
    key: "updateDomainsScalesAndAxes",
    value: function updateDomainsScalesAndAxes(data) {
      var _this4 = this;

      return new Promise(function (resolve) {
        // Set the ranges
        var totalXDomain = d3Legacy.extent(getAllDates(data));
        var totalYDomain = d3Legacy.extent(getAllValues(data));

        _this4.state.xAxisScale.domain(totalXDomain).range([0, _this4.state.currentGraphWidth]);

        _this4.state.xBrushAxisScale.domain(totalXDomain).range([0, _this4.state.currentGraphWidth]);

        _this4.state.yAxisScale.domain(totalYDomain).range([GRAPH_HEIGHT, 0]);

        _this4.state.xAxisInfo.scale(_this4.state.xAxisScale).ticks(_this4.getXTicksGenerator(data));

        _this4.state.xAxisBrush.scale(_this4.state.xBrushAxisScale).ticks(_this4.getXTicksGenerator(data));

        _this4.state.yAxisInfo.scale(_this4.state.yAxisScale);

        _this4.state.brush.x(_this4.state.xBrushAxisScale);

        _this4.state.timeGraphLine.x(function (generator) {
          return mapGeneratorDataPointAndXAxisScaleToGraphX(generator, _this4.state.xAxisScale);
        }).y(function (generator) {
          return mapGeneratorDataPointAndYAxisScaleToGraphY(generator, _this4.state.yAxisScale);
        });

        var updatedState = {
          totalXDomain: totalXDomain,
          totalYDomain: totalYDomain
        };

        if (domainIsOutsideOfTotalDomain(_this4.state.currentXDomain, totalXDomain)) {
          updatedState.currentXDomain = totalXDomain;
        }

        if (domainIsOutsideOfTotalDomain(_this4.state.currentYDomain, totalYDomain)) {
          updatedState.currentYDomain = totalYDomain;
        }

        _this4.setState(updatedState, function () {
          _this4.state.brush.extent(_this4.state.currentXDomain);

          _this4.updateDomainsLinesAndAxes(data);

          resolve();
        });
      });
    }
  }, {
    key: "appendSvgElement",
    value: function appendSvgElement() {
      var _this5 = this;

      // Adds the svg canvas
      return new Promise(function (resolve) {
        var svg = d3Legacy.select(_this5.refs.plotSectionGraph).append('svg').attr('class', 'cosmos-svg--with-overflow');
        var svgDefRect = svg.append('defs').append('clipPath').attr('id', 'clip-multiplot').append('rect');

        _this5.setState({
          svg: svg,
          svgDefRect: svgDefRect
        }, resolve);
      });
    }
  }, {
    key: "updateSvgElement",
    value: function updateSvgElement() {
      this.state.svg.attr('width', this.state.currentTotalWidth).attr('height', TOTAL_HEIGHT);
      this.state.svgDefRect.attr('width', this.state.currentGraphWidth).attr('height', GRAPH_HEIGHT);
    }
  }, {
    key: "appendFocusElement",
    value: function appendFocusElement() {
      var _this6 = this;

      return new Promise(function (resolve) {
        var focusElement = _this6.state.svg.append('g');

        var focusLineGroup = focusElement.append('g').attr('class', 'cosmos-line-group');
        updateD3ElementTranslationXY(focusElement, MARGIN_DESKTOP.left, MARGIN_DESKTOP.top);

        _this6.setState({
          focusElement: focusElement,
          focusLineGroup: focusLineGroup
        }, resolve);
      });
    }
  }, {
    key: "updateFocusLines",
    value: function updateFocusLines(data) {
      var _this7 = this;

      return new Promise(function (resolve) {
        var focusLineElements = _this7.state.focusLineGroup.selectAll('path.cosmos-line').data(data);

        focusLineElements.enter().append('path').attr('class', 'cosmos-line').attr('clip-path', 'url(#clip-multiplot)');
        focusLineElements.exit().remove();
        focusLineElements.style('stroke', mapGeneratorToColor).attr('d', function (generator) {
          return _this7.state.timeGraphLine(mapGeneratorToValues(generator));
        });

        _this7.setState({
          focusLineElements: focusLineElements
        }, resolve);
      });
    }
  }, {
    key: "appendBrushContextElement",
    value: function appendBrushContextElement() {
      var _this8 = this;

      return new Promise(function (resolve) {
        // Brush elements
        var context = _this8.state.svg.append('g');

        updateD3ElementTranslationXY(context, MARGIN_BRUSH_DESKTOP.left, MARGIN_BRUSH_DESKTOP.top);
        var xBrushAxis = context.append('g').attr('class', 'cosmos-axis cosmos-axis--x').attr('transform', "translate(0,".concat(BRUSH_HEIGHT, ")")).call(_this8.state.xAxisBrush);
        var xBrushElement = context.append('g').attr('class', 'cosmos-brush cosmos-brush--x').call(_this8.state.brush);
        xBrushElement.selectAll('rect').attr('y', -6).attr('height', BRUSH_HEIGHT + 7);
        xBrushElement.selectAll('.background').style('visibility', 'visible').attr('rx', 3).attr('ry', 3);
        appendWestResizeIcon(xBrushElement.selectAll('.resize.w'));
        appendEastResizeIcon(xBrushElement.selectAll('.resize.e'));

        _this8.setState({
          xBrushAxis: xBrushAxis,
          xBrushElement: xBrushElement
        }, resolve);
      });
    }
  }, {
    key: "updateBrushContextElement",
    value: function updateBrushContextElement() {
      this.state.xBrushAxis.call(this.state.xAxisBrush);
      this.state.xBrushElement.call(this.state.brush);
    }
  }, {
    key: "appendAxes",
    value: function appendAxes() {
      var _this9 = this;

      return new Promise(function (resolve) {
        var xAxisElement = _this9.state.focusElement.append('g').attr('class', 'cosmos-axis cosmos-axis--x').attr('transform', getTranslateXYString(0, GRAPH_HEIGHT)).call(_this9.state.xAxisInfo);

        var yAxisElement = _this9.state.focusElement.append('g').attr('class', 'cosmos-axis cosmos-axis--y').call(_this9.state.yAxisInfo);

        yAxisElement.append('text').attr('transform', 'rotate(-90)').attr('class', 'cosmos-axis__label').attr('x', Y_AXIS_LABEL_X).attr('y', Y_AXIS_LABEL_Y).text(Y_AXIS_LABEL);

        _this9.setState({
          xAxisElement: xAxisElement,
          yAxisElement: yAxisElement
        }, resolve);
      });
    }
  }, {
    key: "updateAxes",
    value: function updateAxes() {
      this.state.xAxisElement.call(this.state.xAxisInfo);
      this.state.yAxisElement.call(this.state.yAxisInfo);
    }
  }, {
    key: "appendHoverElements",
    value: function appendHoverElements() {
      var _this10 = this;

      // Graph hover elements
      return new Promise(function (resolve) {
        var xCrossHair = _this10.state.svg.append('line').attr('id', 'x-crosshair').attr('class', 'cosmos-crosshair').attr('display', 'none');

        var hoverDate = _this10.state.svg.append('g').attr('display', 'none');

        var hoverDateBox = hoverDate.append('rect').attr('rx', 5).attr('ry', 5).attr('class', 'cosmos-date-box');
        var hoverDateText = hoverDate.append('text').attr('dy', -HOVER_DATE_TOP_BOTTOM_PADDING).attr('text-anchor', 'middle');

        _this10.setState({
          xCrossHair: xCrossHair,
          hoverDate: hoverDate,
          hoverDateBox: hoverDateBox,
          hoverDateText: hoverDateText
        }, resolve);
      });
    }
  }, {
    key: "appendNodesForEachGenerator",
    value: function appendNodesForEachGenerator(data) {
      var _this11 = this;

      return new Promise(function (resolve) {
        _each(_this11.state.nodeElements, function (nodeElement) {
          return nodeElement.remove();
        });

        var nodeElements = {};

        _each(data, function (generator, collectionIndex) {
          Object.assign(nodeElements, _this11.appendNode(SURROUNDING_NODE_SIZE, generator, collectionIndex, PREVIOUS_NODE_KEY), _this11.appendNode(SURROUNDING_NODE_SIZE, generator, collectionIndex, NEXT_NODE_KEY), _this11.appendNode(MAIN_NODE_SIZE, generator, collectionIndex, CURRENT_NODE_KEY));
        });

        _this11.setState({
          nodeElements: nodeElements
        }, resolve);
      });
    }
  }, {
    key: "appendNode",
    value: function appendNode(nodeSize, generator, collectionIndex, prevNextCurrent) {
      var nodeString = constructNodeString(collectionIndex, prevNextCurrent);
      var collectionColor = mapGeneratorToColor(generator);
      var nodeElement = this.state.svg.append('g').attr('class', "cosmos-focus-node cosmos-focus-node--".concat(nodeString)).attr('display', 'none');
      nodeElement.append('circle').attr('fill', collectionColor).attr('stroke', collectionColor).attr('r', nodeSize);

      if (prevNextCurrent !== CURRENT_NODE_KEY) {
        return _defineProperty({}, nodeString, nodeElement);
      }

      nodeElement.append('rect').attr('class', 'cosmos-focus-node__tooltip').attr('stroke', collectionColor).attr('rx', '5px').attr('ry', '5px');
      nodeElement.append('text').attr('class', 'cosmos-focus-node__tooltip-text');
      return _defineProperty({}, nodeString, nodeElement);
    }
  }, {
    key: "appendOverlayElement",
    value: function appendOverlayElement() {
      var _this12 = this;

      return new Promise(function (resolve) {
        var overlayElement = _this12.state.svg.append('rect').attr('class', 'cosmos-overlay').attr('height', GRAPH_HEIGHT).attr('transform', getTranslateXYString(MARGIN_DESKTOP.left, MARGIN_DESKTOP.top)).on('mouseout', _this12._hideAllHoverElements);

        _this12.setState({
          overlayElement: overlayElement
        }, resolve);
      });
    }
  }, {
    key: "updateOverlayElement",
    value: function updateOverlayElement(data) {
      var onMouseMoveOver = this.onMouseMoveOverOverlayElementGenerator(data);
      this.state.overlayElement.attr('width', this.state.currentGraphWidth).on('mouseover', onMouseMoveOver).on('mousemove', onMouseMoveOver);
    }
  }, {
    key: "onMouseMoveOverOverlayElementGenerator",
    value: function onMouseMoveOverOverlayElementGenerator(data) {
      var timeGraphSelf = this;
      return function () {
        // Hide all of the elements in case they don't get redrawn
        timeGraphSelf._hideAllHoverElements();

        if (!data.length) return;
        var closestDate = timeGraphSelf.state.xAxisScale.invert(d3Legacy.mouse(this)[0]);
        var fullDataXExtent = d3Legacy.extent(getAllDates(data));
        var firstFullExtentGenerator = timeGraphSelf.mapAllGeneratorDataToFirstFullRangeGenerator(data, fullDataXExtent);
        var firstFullExtentGeneratorIndex = bisectDate(mapGeneratorToValues(firstFullExtentGenerator), closestDate);
        var firstFullExtentGeneratorDataPoint = mapGeneratorToValues(firstFullExtentGenerator)[firstFullExtentGeneratorIndex];
        if (!firstFullExtentGeneratorDataPoint) return;
        var firstFullExtentGeneratorDate = mapGeneratorDataPointToXValue(firstFullExtentGeneratorDataPoint);
        timeGraphSelf.positionAndShowXCrossHair(firstFullExtentGeneratorDate);
        timeGraphSelf.positionAndShowHoverDate(firstFullExtentGeneratorDate);

        _each(data, function (generator, collectionIndex) {
          var currentIndex = bisectDate(mapGeneratorToValues(generator), closestDate);
          var currentDataPoint = mapGeneratorToValues(generator)[currentIndex];
          var currentDate = mapGeneratorDataPointToXValue(currentDataPoint); // If this data point is more than a day away, don't show it

          if (currentDate - firstFullExtentGeneratorDate > MS_IN_A_DAY) return;
          this.positionAndShowNode(mapGeneratorToValues(generator)[currentIndex - timeGraphSelf.props.surroundingNodeDistance], PREVIOUS_NODE_KEY, mapGeneratorToName(generator), collectionIndex);
          this.positionAndShowNode(mapGeneratorToValues(generator)[currentIndex + timeGraphSelf.props.surroundingNodeDistance], NEXT_NODE_KEY, mapGeneratorToName(generator), collectionIndex);
          this.positionAndShowNode(currentDataPoint, CURRENT_NODE_KEY, mapGeneratorToName(generator), collectionIndex);
        }.bind(timeGraphSelf));
      };
    }
  }, {
    key: "positionAndShowXCrossHair",
    value: function positionAndShowXCrossHair(currentDate) {
      var xPosition = this.state.xAxisScale(currentDate);
      if (xPosition < 0 || xPosition > this.state.currentGraphWidth) return;
      this.state.xCrossHair.attr('x1', MARGIN_DESKTOP.left + xPosition).attr('y1', MARGIN_DESKTOP.top + this.state.yAxisScale(this.state.currentYDomain[0])).attr('x2', MARGIN_DESKTOP.left + xPosition).attr('y2', MARGIN_DESKTOP.top + HOVER_DATE_TOP_MARGIN + this.state.yAxisScale(this.state.currentYDomain[1])).attr('display', null);
    }
  }, {
    key: "positionAndShowHoverDate",
    value: function positionAndShowHoverDate(currentDate) {
      var xPosition = this.state.xAxisScale(currentDate);
      if (xPosition < 0 || xPosition > this.state.currentGraphWidth) return;
      updateD3ElementTranslationXY(this.state.hoverDate, MARGIN_DESKTOP.left + xPosition, MARGIN_DESKTOP.top + HOVER_DATE_TOP_MARGIN + this.state.yAxisScale(this.state.currentYDomain[1]));
      showD3Element(this.state.hoverDate);
      this.state.hoverDateText.text(this.formatHoverDate(currentDate));
      var textBBox = this.state.hoverDateText[0][0].getBBox();
      this.state.hoverDateBox.attr('height', textBBox.height + 2 * HOVER_DATE_TOP_BOTTOM_PADDING).attr('width', textBBox.width + 2 * HOVER_DATE_SIDE_PADDING).attr('y', textBBox.y - HOVER_DATE_TOP_BOTTOM_PADDING).attr('x', textBBox.x - HOVER_DATE_SIDE_PADDING);
    }
  }, {
    key: "positionAndShowNode",
    value: function positionAndShowNode(dataPoint, prevNextCurrent, collectionTitle, collectionIndex) {
      if (!dataPoint) return;
      var nodeElement = this.state.nodeElements[constructNodeString(collectionIndex, prevNextCurrent)];
      if (!nodeElement || mapGeneratorDataPointAndXAxisScaleToGraphX(dataPoint, this.state.xAxisScale) < 0 || mapGeneratorDataPointAndXAxisScaleToGraphX(dataPoint, this.state.xAxisScale) > this.state.currentGraphWidth || mapGeneratorDataPointAndYAxisScaleToGraphY(dataPoint, this.state.yAxisScale) < 0 || mapGeneratorDataPointAndYAxisScaleToGraphY(dataPoint, this.state.yAxisScale) > GRAPH_HEIGHT) return;
      var nodePositionX = MARGIN_DESKTOP.left + mapGeneratorDataPointAndXAxisScaleToGraphX(dataPoint, this.state.xAxisScale);
      var nodePositionY = MARGIN_DESKTOP.top + mapGeneratorDataPointAndYAxisScaleToGraphY(dataPoint, this.state.yAxisScale);
      updateD3ElementTranslationXY(nodeElement, nodePositionX, nodePositionY);
      showD3Element(nodeElement);
      if (prevNextCurrent !== CURRENT_NODE_KEY) return;
      var nodeText = nodeElement.select('text');
      var nodeRect = nodeElement.select('rect');
      nodeText.style('text-anchor', 'end').attr('x', -TOOLTIP_X_MARGIN).attr('y', TOOLTIP_Y_MARGIN).text("".concat(collectionTitle, ": ").concat(_toInteger(mapGeneratorDataPointToYValue(dataPoint)), " ").concat(Y_AXIS_LABEL));
      var textBBox = nodeText[0][0].getBBox();

      if (nodePositionX < this.state.currentGraphWidth / 2) {
        nodeText.style('text-anchor', 'start').attr('x', TOOLTIP_X_MARGIN);
        textBBox = nodeText[0][0].getBBox();
      }

      nodeRect.attr('width', textBBox.width + TOOLTIP_SIDE_PADDING * 2).attr('height', textBBox.height + TOOLTIP_TOP_BOTTOM_PADDING * 2).attr('x', textBBox.x - TOOLTIP_SIDE_PADDING).attr('y', textBBox.y - TOOLTIP_TOP_BOTTOM_PADDING);
    }
  }, {
    key: "updateDomainsLinesAndAxes",
    value: function updateDomainsLinesAndAxes(data) {
      var _this13 = this;

      return new Promise(function (resolve) {
        var currentXDomain = _this13.state.brush.empty() ? _this13.state.totalXDomain : _this13.state.brush.extent();

        _this13.state.xAxisScale.domain(currentXDomain);

        var currentYDomain = _this13.state.brush.empty() ? _this13.state.totalYDomain : _this13.getCurrentYDomainExtent(data);

        _this13.state.yAxisScale.domain(currentYDomain);

        _this13.state.focusLineElements.attr('d', function (generator) {
          return _this13.state.timeGraphLine(mapGeneratorToValues(generator));
        });

        _this13.state.xAxisElement.call(_this13.state.xAxisInfo);

        _this13.state.yAxisElement.call(_this13.state.yAxisInfo);

        _this13.setState({
          currentXDomain: currentXDomain,
          currentYDomain: currentYDomain
        }, resolve);
      });
    }
  }, {
    key: "bindBrush",
    value: function bindBrush(data) {
      this.state.brush.on('brush', this.onBrushGenerator(data));
    }
  }, {
    key: "onBrushGenerator",
    value: function onBrushGenerator(data) {
      var timeGraphSelf = this;
      return function () {
        // Hide interactive elements on brush - useful for mobile
        timeGraphSelf._hideAllHoverElements();

        if (!d3Legacy.event.sourceEvent) return; // only transition after input

        if (!data.length) return;
        var brushExtent = timeGraphSelf.state.brush.extent();
        var generatorDataWithFullExtent = timeGraphSelf.mapAllGeneratorDataToFirstFullRangeGenerator(data);
        var extentStartIndex = bisectDate(mapGeneratorToValues(generatorDataWithFullExtent), brushExtent[0]);
        var extentEndIndex = bisectDate(mapGeneratorToValues(generatorDataWithFullExtent), brushExtent[1]); // Require at least two data points

        if (extentStartIndex === extentEndIndex && mapGeneratorToValues(generatorDataWithFullExtent)[extentEndIndex + 1]) {
          extentEndIndex++;
        } else if (extentStartIndex === extentEndIndex && mapGeneratorToValues(generatorDataWithFullExtent)[extentStartIndex - 1]) {
          extentStartIndex--;
        }

        var startDateUpdated = mapGeneratorDataPointToXValue(mapGeneratorToValues(generatorDataWithFullExtent)[extentStartIndex]);
        var endDateUpdated = mapGeneratorDataPointToXValue(mapGeneratorToValues(generatorDataWithFullExtent)[extentEndIndex]);
        var brushXDomain = [startDateUpdated, endDateUpdated];
        timeGraphSelf.state.brush.extent(brushXDomain);
        d3Legacy.select(this).transition().duration(0).call(timeGraphSelf.state.brush.event);
        timeGraphSelf.updateDomainsLinesAndAxes(data);
      };
    }
  }, {
    key: "getXTicksGenerator",
    value: function getXTicksGenerator(data) {
      var _this14 = this;

      return function (startDate, endDate) {
        if (!data.length) return [];

        var validGenerator = _this14.mapAllGeneratorDataToFirstFullRangeGenerator(data);

        var currentIndex = bisectDate(mapGeneratorToValues(validGenerator), startDate);
        var currentDataPoint = mapGeneratorToValues(validGenerator)[currentIndex];
        var dateTicks = [];
        var timeDifference = endDate - startDate;
        var timeDifferenceBetweenDataPoints = mapGeneratorDataPointToXValue(mapGeneratorToValues(validGenerator)[1]) - mapGeneratorDataPointToXValue(mapGeneratorToValues(validGenerator)[0]);

        var incrementBy = _ceil(timeDifference / _this14.state.maxNumberOfXTicks / timeDifferenceBetweenDataPoints);

        while (currentDataPoint && mapGeneratorDataPointToXValue(currentDataPoint).getTime() <= endDate.getTime()) {
          dateTicks.push(mapGeneratorDataPointToXValue(currentDataPoint));
          currentIndex += incrementBy;
          currentDataPoint = mapGeneratorToValues(validGenerator)[currentIndex];
        }

        return dateTicks;
      };
    } // TODO: do we need to do all this?

  }, {
    key: "getCurrentYDomainExtent",
    value: function getCurrentYDomainExtent(data) {
      var _this15 = this;

      var selectedData = _map(data, function (generator) {
        var filteredValues = _filter(mapGeneratorToValues(generator), function (dataPoint) {
          var dataPointDateTime = mapGeneratorDataPointToXValue(dataPoint).getTime();
          return dataPointDateTime >= _this15.state.currentXDomain[0].getTime() && dataPointDateTime <= _this15.state.currentXDomain[1].getTime();
        });

        return Object.assign({}, generator, {
          values: filteredValues
        });
      });

      return d3Legacy.extent(getAllValues(selectedData));
    }
  }, {
    key: "mapAllGeneratorDataToFirstFullRangeGenerator",
    value: function mapAllGeneratorDataToFirstFullRangeGenerator(data, fullRange) {
      var _this16 = this;

      return _find(data, function (dataCollection) {
        return _this16.dataCollectionHasFullExtent(dataCollection, fullRange);
      });
    }
  }, {
    key: "dataCollectionHasFullExtent",
    value: function dataCollectionHasFullExtent(dataCollection) {
      var fullExtent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.totalXDomain;
      return _isEqual(d3Legacy.extent(_map(mapGeneratorToValues(dataCollection), mapGeneratorDataPointToXValue)), fullExtent);
    }
  }, {
    key: "formatHoverDate",
    value: function formatHoverDate(d) {
      return getCurrentD3Locale().timeFormat(this.props.hoverDateFormatting)(d);
    }
  }, {
    key: "plotSectionGraphClasses",
    value: function plotSectionGraphClasses() {
      var classes = [];
      if (!this.props.plotData.length) classes.push('data-page__section__graph--hidden');
      return classes.join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "row"
      }, this.props.isMobileWidth ? null : React.createElement(SelectedGeneratorsDesktop, {
        plotId: this.props.plotId
      }, React.createElement(PlotSampleRateRadios, {
        plotId: this.props.plotId,
        possibleSampleRates: this.props.possibleSampleRates,
        plotDataUpdating: this.props.plotDataUpdating
      })), React.createElement("div", {
        className: "col-sm-8 col-md-9"
      }, React.createElement("div", {
        className: "data-page__section__graph data-page__section__graph--multiplot"
      }, this.props.plotDataUpdating ? React.createElement("div", {
        className: "loading-spinner-translucent-overlay"
      }, React.createElement("div", {
        className: "loading-spinner loading-spinner--centered-within-parent loading-spinner--translucent"
      })) : null, React.createElement("div", {
        ref: "plotSectionGraph",
        id: this.props.plotSectionGraphId,
        className: this.plotSectionGraphClasses()
      }), !this.props.plotData.length ? React.createElement("div", {
        className: "data-page__section__graph--hidden__empty"
      }, React.createElement("div", {
        className: "data-page__section__graph--hidden__empty__text"
      }, this.props.noGeneratorsSelectedText)) : null)), this.props.isMobileWidth ? React.createElement(SelectedGeneratorsMobile, {
        plotId: this.props.plotId
      }, React.createElement(PlotSampleRateRadios, {
        plotId: this.props.plotId,
        possibleSampleRates: this.props.possibleSampleRates,
        plotDataUpdating: this.props.plotDataUpdating
      })) : null, React.createElement(GraphDownloadButton, {
        plotMetadata: this.props.plotMetadata,
        plotDateRange: this.state.currentXDomain,
        plotDateRangeTotal: this.state.totalXDomain,
        plotDateRangeUpdate: this._plotDateRangeUpdate,
        plotSelectedSampleRate: this.props.plotSelectedSampleRate,
        possibleSampleRates: this.props.possibleSampleRates
      }));
    }
  }]);

  return TimeGraph;
}(React.Component);

TimeGraph.propTypes = {
  isMobileWidth: PropTypes.bool.isRequired,
  windowWidth: PropTypes.number.isRequired,
  surroundingNodeDistance: PropTypes.number.isRequired,
  plotId: PropTypes.string.isRequired,
  plotSectionId: PropTypes.string.isRequired,
  plotSectionGraphId: PropTypes.string.isRequired,
  plotCountryCode: PropTypes.string.isRequired,
  plotSelectedSampleRate: PropTypes.string.isRequired,
  plotGenerators: PropTypes.object.isRequired,
  plotData: PropTypes.array.isRequired,
  plotMetadata: PropTypes.object.isRequired,
  plotDataUpdating: PropTypes.bool.isRequired,
  hoverDateFormatting: PropTypes.string.isRequired,
  noGeneratorsSelectedText: PropTypes.string.isRequired,
  possibleSampleRates: PropTypes.array.isRequired
};
export { TimeGraph as default };

function constructNodeString(collectionIndex, prevNextCurrent) {
  return collectionIndex + prevNextCurrent;
}

function getAllDates(data) {
  return mapAllDataValues(data, mapGeneratorDataPointToXValue);
}

function getAllValues(data) {
  return mapAllDataValues(data, mapGeneratorDataPointToYValue);
}

function mapAllDataValues(dataSource, mapMethod) {
  return _flatten(_map(dataSource, function (dataCollection) {
    return _map(mapGeneratorToValues(dataCollection), mapMethod);
  }));
}

export function appendWestResizeIcon(resizeElement) {
  var resizeWSvg = resizeElement.append('svg').attr('x', '-50%').attr('y', -7).attr('height', 19).attr('viewBox', '0 0 44 44');
  var wLineG = resizeWSvg.append('g');
  wLineG.append('path').attr('class', 'cosmos-svg__st0').attr('d', 'M12,43C5.9,43,1,38.1,1,32V12C1,5.9,5.9,1,12,1h31v42H12z');
  wLineG.append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M42,2v40H12C6.5,42,2,37.5,2,32V12C2,6.5,6.5,2,12,2H42 M44,0h-2H12C5.4,0,0,5.4,0,12v20c0,6.6,5.4,12,12,12h30h2v-2V2V0L44,0z');
  resizeWSvg.append('g').append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M28.8,32L28.8,32c-0.6,0-1-0.4-1-1V13c0-0.6,0.4-1,1-1h0c0.6,0,1,0.4,1,1v18C29.8,31.6,29.3,32,28.8,32z');
  resizeWSvg.append('g').append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M19,32L19,32c-0.6,0-1-0.4-1-1V13c0-0.6,0.4-1,1-1h0c0.6,0,1,0.4,1,1v18C20,31.6,19.6,32,19,32z');
}
export function appendEastResizeIcon(resizeElement) {
  var resizeESvg = resizeElement.append('svg').attr('x', '-50%').attr('y', -7).attr('height', 19).attr('viewBox', '0 0 44 44');
  var eLineG = resizeESvg.append('g');
  eLineG.append('path').attr('class', 'cosmos-svg__st0').attr('d', 'M1,43V1h31c6.1,0,11,4.9,11,11v20c0,6.1-4.9,11-11,11H1z');
  eLineG.append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M32,2c5.5,0,10,4.5,10,10v20c0,5.5-4.5,10-10,10H2V2H32 M32,0H2H0v2v40v2h2h30c6.6,0,12-5.4,12-12V12C44,5.4,38.6,0,32,0L32,0z');
  resizeESvg.append('g').append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M15.2,12L15.2,12c0.6,0,1,0.4,1,1v18c0,0.6-0.4,1-1,1h0c-0.6,0-1-0.4-1-1V13C14.2,12.4,14.7,12,15.2,12z');
  resizeESvg.append('g').append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M25,12L25,12c0.6,0,1,0.4,1,1v18c0,0.6-0.4,1-1,1h0c-0.6,0-1-0.4-1-1V13C24,12.4,24.4,12,25,12z');
}

function updateD3ElementAttribute(element, attributeName, attributeValue) {
  element.attr(attributeName, attributeValue);
}

function getTranslateXYString(x, y) {
  return "translate(".concat(x, ", ").concat(y, ")");
}

function updateD3ElementTranslationXY(element, x, y) {
  updateD3ElementAttribute(element, 'transform', getTranslateXYString(x, y));
}

function showD3Element(element) {
  updateD3ElementAttribute(element, 'display', null);
}

function hideD3Element(element) {
  updateD3ElementAttribute(element, 'display', 'none');
}

function formatBrushXAxisDate(d) {
  return getCurrentD3Locale().timeFormat('%b %e')(d);
}

function mapGeneratorDataPointAndXAxisScaleToGraphX(generatorDataPoint, xAxisScale) {
  return xAxisScale(mapGeneratorDataPointToXValue(generatorDataPoint));
}

function mapGeneratorDataPointAndYAxisScaleToGraphY(generatorDataPoint, yAxisScale) {
  return yAxisScale(mapGeneratorDataPointToYValue(generatorDataPoint));
}

export function mapGeneratorDataPointToXValue(generatorDataPoint) {
  // x value is a date
  return generatorDataPoint[0];
}
export function mapGeneratorDataPointToYValue(generatorDataPoint) {
  // y value is a number
  return generatorDataPoint[1];
}
export function mapGeneratorToId(generator) {
  return generator.id;
}
export function mapGeneratorToName(generator) {
  return generator.name;
}
export function mapGeneratorToType(generator) {
  return generator.type;
}
export function mapGeneratorToColor(generator) {
  return generator.color;
}
export function mapGeneratorToIsAggregate(generator) {
  return !!generator.isAggregate;
}
export function mapGeneratorToValues(generator) {
  return generator.values;
}

function domainIsOutsideOfTotalDomain(domain, totalDomain) {
  return !domain || domain[0] < totalDomain[0] || domain[1] > totalDomain[1];
}